import { c as _c } from "react/compiler-runtime";
import { runtimeConfig } from "@src/runtime-config";
import { Link } from "@flat-ui";
import { contactSupport } from "@utils/email-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Creates a simple component to show a link to contact support */
export function SphereSupportLink(t0) {
  const $ = _c(4);
  const {
    location
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      verticalAlign: "baseline"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== location || $[2] !== trackEvent) {
    t2 = <Link component="button" sx={t1} onClick={() => contactSupport({
      location,
      trackEvent
    })}>{runtimeConfig.mailSupportAddress}</Link>;
    $[1] = location;
    $[2] = trackEvent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}